import type { Language } from '../i18n';

/**
 * Display labels for garden component IDs.
 * Single source of truth for plan views, gardener views, etc.
 */
export const COMPONENT_LABELS: Record<string, { en: string; de: string; hr: string }> = {
	'pool': { en: 'Pool', de: 'Pool', hr: 'Bazen' },
	'fence': { en: 'Fence', de: 'Zaun', hr: 'Ograda' },
	'bbq': { en: 'BBQ', de: 'Grillbereich', hr: 'Roštilj' },
	'lounge': { en: 'Lounge', de: 'Lounge', hr: 'Lounge' },
	'outdoor-kitchen': { en: 'Outdoor Kitchen', de: 'Außenküche', hr: 'Vanjska kuhinja' },
	'fire-pit': { en: 'Fire Pit', de: 'Feuerstelle', hr: 'Vatreno ložište' },
	'pergola': { en: 'Pergola', de: 'Pergola', hr: 'Pergola' },
	'deck': { en: 'Deck', de: 'Terrasse', hr: 'Terasa' },
	'shed': { en: 'Shed', de: 'Gartenhaus', hr: 'Vrtna kućica' },
	'playground': { en: 'Playground', de: 'Spielplatz', hr: 'Igralište' },
	'vegetable-garden': { en: 'Vegetable Garden', de: 'Gemüsegarten', hr: 'Povrtnjak' },
	'water-feature': { en: 'Water Feature', de: 'Wasserelement', hr: 'Vodeni element' },
	'lighting': { en: 'Lighting', de: 'Beleuchtung', hr: 'Rasvjeta' },
	'pathway': { en: 'Pathway', de: 'Weg', hr: 'Staza' },
	'retaining-wall': { en: 'Retaining Wall', de: 'Stützmauer', hr: 'Potporni zid' },
	'driveway': { en: 'Driveway', de: 'Einfahrt', hr: 'Prilaz' },
	'greenhouse': { en: 'Greenhouse', de: 'Gewächshaus', hr: 'Staklenik' },
	'flower-beds': { en: 'Flower Beds', de: 'Blumenbeete', hr: 'Cvjetne gredice' },
	'hot-tub': { en: 'Hot Tub', de: 'Whirlpool', hr: 'Hidromasažna kada' },
	'pizza-oven': { en: 'Pizza Oven', de: 'Pizzaofen', hr: 'Peć za pizzu' },
	'compost': { en: 'Compost Area', de: 'Kompostbereich', hr: 'Kompostište' }
};

export function getComponentLabel(componentId: string, language: Language = 'en'): string {
	const labels = COMPONENT_LABELS[componentId];
	if (!labels) return componentId;
	if (language === 'de') return labels.de;
	if (language === 'hr') return labels.hr;
	return labels.en;
}
